import { render } from "./IssueDetail.vue?vue&type=template&id=5b622fe4&scoped=true"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"

import "./IssueDetail.vue?vue&type=style&index=0&id=5b622fe4&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b622fe4"]])

export default __exports__